import * as React from 'react';
import * as ReactDOM from 'react-dom';

import {Text, TextContext} from './quickscan/TextContext';
import {FormProvider} from './quickscan/view/form/FormContext';
import {Form} from './quickscan/view/form/Form';
import {Modal} from './modal';
import {$$} from "./util/$$";
import {FormField} from "./quickscan/data/reviewForm";

// tslint:disable-next-line:function-name
function ReviewButton(): JSX.Element {
    const text: Text = React.useContext(TextContext);

    function handleShowForm(): void {
        const wrapper: HTMLElement = document.createElement('div');

        ReactDOM.render(
            <FormProvider
                questions={text.review_fields as FormField[]}
                personal={text.personal_fields as FormField[]}
                subject={`${text.form_button}`}
                //scans={state.scans}
            >
                <Form text={text}/>
            </FormProvider>,
            wrapper,
        );

        Modal.open(
            text.form_modal_title as string,
            wrapper,
            't-orange--tangerine',
            undefined,
            true,
        );
    }

    return <button
        onClick={handleShowForm}
        type="button"
        className="c-review__save  o-button  o-button--bordered  o-button--bordered-animated"
    >
        {text.form_button}
    </button>;
}

// tslint:disable-next-line function-name
export function review(): void {
    //const { state, dispatch } = React.useContext(StateContext);
    const elements: HTMLDivElement[] = $$('.js-review') as HTMLDivElement[];

    for (const element of elements) {
        const text: Text = JSON.parse(
            element.getAttribute('data-text') as string,
        );

        ReactDOM.render(
            <TextContext.Provider value={text}>
                <ReviewButton/>
            </TextContext.Provider>,
            element,
        );
    }
}
